var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ContentLayout", {
        ref: "print",
        attrs: {
          title: _vm.$t("label_essweb_admin_RosterRecord_list_title"),
          pad: "0",
          filterable: "",
          backgroundClass: "transparent",
          widthClass: "min-1200",
        },
        on: {
          filter: function (val) {
            _vm.filterPageData = val
          },
        },
        scopedSlots: _vm._u([
          {
            key: "top-selection",
            fn: function (ref) {
              var filter = ref.filter
              return [
                _c(
                  "v-container",
                  {
                    staticClass: "d-flex pa-0 ma-0 justify-space-around",
                    attrs: { fluid: "" },
                  },
                  [
                    !_vm.isEdited
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "d-flex flex-row justify-end transparent",
                          },
                          [
                            false
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-capitalize ml-n6",
                                    attrs: {
                                      text: "",
                                      color: "primary",
                                      depressed: "",
                                      rounded: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.toDo = "recalculate"
                                        _vm.showRecalcul = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_RosterRecord_list_recalulateBtnLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.hasBtn("admin-roster-schedule-initialize")
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-capitalize ml-n3",
                                    attrs: {
                                      text: "",
                                      ripple: false,
                                      color: "primary  ",
                                      depressed: "",
                                      rounded: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.toDo = "regenerate"
                                        _vm.showRecalcul = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_RosterRecord_list_regenerateBtnLabel"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-spacer"),
                    _c("Selections2", {
                      attrs: { objects: _vm.filterObjects, "small-chip": "" },
                      on: {
                        filter: function ($event) {
                          filter()
                          _vm.toFilter(filter)
                        },
                        update: function (prop, value, selected) {
                          if (prop == "department") {
                            _vm.curDept = value
                          } //触发岗位更新下拉
                          _vm.$fliterValue(
                            _vm.filterObjects,
                            prop,
                            value,
                            selected
                          )
                        },
                        reset: function (apply) {
                          _vm.$fliterValue(_vm.filterObjects, null, null)
                          if (apply) {
                            filter()
                            _vm.toFilter(filter)
                          }
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "nav-actions",
            fn: function () {
              return [
                _vm.hasBtn("export-admin-roster-schedule")
                  ? _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isEdited,
                            expression: "!isEdited",
                          },
                        ],
                        staticClass: "primary mr-4",
                        attrs: {
                          icon: "",
                          color: "white",
                          width: "40",
                          height: "40",
                        },
                        on: {
                          click: function ($event) {
                            _vm
                              .$confirmWarn(
                                _vm.$t(
                                  "label_essweb_RosterRecord_list_exportOutBtnLabel"
                                ),
                                _vm.$t(
                                  "message_essweb_system_operation_export_outLabel"
                                ),
                                null,
                                _vm.$t(
                                  "message_essweb_system_operation_export_exportOutLabel"
                                )
                              )
                              .then(function (res) {
                                if (res) {
                                  _vm.showExportOut = true
                                }
                              })
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: { size: "24", iconClass: "export" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasBtn("import-admin-roster-schedule")
                  ? _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isEdited,
                            expression: "!isEdited",
                          },
                        ],
                        staticClass: "primary mr-4",
                        attrs: {
                          icon: "",
                          color: "white",
                          width: "40",
                          height: "40",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showExportIn = !_vm.showExportIn
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: { size: "24", iconClass: "import" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasBtn("admin-roster-schedule-generate-roster-form")
                  ? _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isEdited,
                            expression: "!isEdited",
                          },
                        ],
                        staticClass: "primary mr-4",
                        attrs: {
                          icon: "",
                          color: "white",
                          width: "40",
                          height: "40",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showRosterForm = true
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: { size: "24", iconClass: "calendar_roster" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                0
                  ? _c(
                      "v-menu",
                      {
                        staticClass: "rounded-lg",
                        attrs: {
                          bottom: "",
                          "offset-y": "",
                          "close-on-content-click": false,
                          "nudge-left": "250",
                          "nudge-top": "-6",
                          origin: "top right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.isEdited,
                                              expression: "!isEdited",
                                            },
                                          ],
                                          staticClass: "text-capitalize mr-4",
                                          attrs: {
                                            color: "primary",
                                            rounded: "",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterRecord_list_generalRosterBtnLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4131751502
                        ),
                        model: {
                          value: _vm.showMenu,
                          callback: function ($$v) {
                            _vm.showMenu = $$v
                          },
                          expression: "showMenu",
                        },
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "pa-0 ma-0", attrs: { width: "400" } },
                          [
                            _c(
                              "v-card-text",
                              { staticClass: "pa-0 ma-0" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    attrs: { "lazy-validation": "" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "pa-3 pb-0",
                                        attrs: {
                                          justify: "center",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-0",
                                            attrs: {
                                              xs: "12",
                                              sm: "12",
                                              md: "12",
                                              lg: "12",
                                              cols: "12",
                                            },
                                          },
                                          [
                                            _c("DateTimePicker", {
                                              attrs: {
                                                type: "daterange",
                                                isRequire: "",
                                                canDelete: false,
                                                value: _vm.dateTerminal,
                                                defaultStartTime:
                                                  _vm.defaultStartDate,
                                                defaultEndTime:
                                                  _vm.defaultEndDate,
                                                placeholder: _vm.$t(
                                                  "label_essweb_RosterRecord_list_seTimeLabel"
                                                ),
                                              },
                                              on: {
                                                change: function (time, isre) {
                                                  _vm.dateTerminal = time
                                                  if (isre) {
                                                    _vm.defaultStartDate = time
                                                      ? time.split(" - ")[0]
                                                      : ""
                                                    _vm.defaultEndDate = time
                                                      ? time.split(" - ")[1]
                                                      : ""
                                                  }
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("CardActions", {
                              attrs: { okBtn: "" },
                              on: {
                                cancel: function ($event) {
                                  _vm.showMenu = false
                                  _vm.reviewDateTerminal()
                                },
                                ok: function ($event) {
                                  return _vm.setDateTerminal()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "page-main",
            fn: function () {
              return [
                false
                  ? _c(
                      "v-app-bar",
                      {
                        staticClass: "mrc-grey pa-0",
                        attrs: { elevation: "0", dense: "" },
                      },
                      [
                        !_vm.isEdited
                          ? _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "d-flex flex-row justify-end transparent",
                              },
                              [
                                false
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "text-capitalize ml-n6",
                                        attrs: {
                                          text: "",
                                          color: "primary",
                                          depressed: "",
                                          rounded: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.toDo = "recalculate"
                                            _vm.showRecalcul = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_RosterRecord_list_recalulateBtnLabel"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-capitalize ml-n3",
                                    attrs: {
                                      text: "",
                                      ripple: false,
                                      color: "primary  ",
                                      depressed: "",
                                      rounded: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.toDo = "regenerate"
                                        _vm.showRecalcul = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_RosterRecord_list_regenerateBtnLabel"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("v-spacer"),
                        _vm.isEdited
                          ? _c(
                              "v-sheet",
                              { attrs: { width: "400", color: "transparent" } },
                              [
                                _c("DateTimePicker", {
                                  attrs: {
                                    type: "daterange",
                                    isRequire: "",
                                    canDelete: false,
                                    appendIcon: "event",
                                    disable: true,
                                    value: _vm.dateTerminal,
                                    defaultStartTime: _vm.defaultStartDate,
                                    defaultEndTime: _vm.defaultEndDate,
                                    placeholder: _vm.$t(
                                      "label_essweb_RosterRecord_list_seTimeLabel"
                                    ),
                                  },
                                  on: {
                                    change: function (time, isre) {
                                      _vm.dateTerminal = time
                                      if (isre) {
                                        _vm.defaultStartDate = time
                                          ? time.split(" - ")[0]
                                          : ""
                                        _vm.defaultEndDate = time
                                          ? time.split(" - ")[1]
                                          : ""
                                      }
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("RosterPlan", {
                  ref: "printarea2",
                  attrs: {
                    cycleType: _vm.cycleType,
                    showExportIn: _vm.showExportIn,
                    toDo: _vm.toDo,
                    hasPermission: _vm.hasBtn("edit-admin-roster-schedule"),
                    showRosterForm: _vm.showRosterForm,
                    showRecalcul: _vm.showRecalcul,
                    startTime: _vm.startTime,
                    isEdited: _vm.isEdited,
                    "filter-data": _vm.filterData,
                    selectStartDate: _vm.startDate,
                    selectEndDate: _vm.endDate,
                    endTime: _vm.endTime,
                  },
                  on: {
                    closeExportIn: function ($event) {
                      _vm.showExportIn = false
                    },
                    closeCalcul: function ($event) {
                      _vm.showRecalcul = false
                    },
                    back: function ($event) {
                      _vm.isEdited = false
                      _vm.dateTerminal = ""
                    },
                    reset: function (e) {
                      if (e) {
                        _vm.$fliterValue(_vm.filterObjects, null, null)
                      }
                    },
                    closeRosterForm: function ($event) {
                      _vm.showRosterForm = false
                    },
                    onTrigerPage: function (logic, time) {
                      _vm.toResetTime(logic, time)
                    },
                    check: function (staffs) {
                      _vm.selectStaffs = staffs
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "tools-main",
            fn: function () {
              return [
                _c("ExportOut", {
                  attrs: { show: _vm.showExportOut },
                  on: {
                    export: _vm.exportOut,
                    close: function ($event) {
                      _vm.showExportOut = false
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "page-actions",
            fn: function () {
              return [
                _vm.isEdited
                  ? _c("CardActions", {
                      attrs: {
                        step: _vm.step == _vm.curStep ? false : true,
                        preStep: _vm.curStep > 1 ? true : false,
                      },
                      on: {
                        next: _vm.toNext,
                        pre: function ($event) {
                          _vm.curStep = _vm.curStep - 1
                        },
                        cancel: function ($event) {
                          _vm.isEdited = false
                          _vm.dateTerminal = ""
                        },
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }